.mfa-header {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-big);
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 0;
}
